<template>
    <PortalAuth>
        <div class="d-flex align-items-center min-vh-100">
            <CContainer fluid>
                <CRow class="justify-content-center">
                    <CCol lg="8" xl="6">
                        <CCard class="mb-0">
                            <CCardBody class="p-4">
                                <CForm @submit.prevent="onSubmit">
                                    <h2 class="text-success" style="text-align:center">Dear coaches and rowers,</h2><br>
                                    <p class="text-muted text-justify show">Thank you for registering!<br><br>
                                        We're here to provide a tool to refine technique and accelerate your improvement. We analyze and telestrate your footage frame by frame within a few minutes. That lets you focus on the things
                                        that are really important: coaching and rowing.</p>
                                    <p class="text-muted py-2 ">Best Regards, <br>
                                        Your RowerUp team.</p>
                                    <p class="text-muted text-justify show"> <b>Before proceeding, please tell us who you are:</b> </p>
                                    <CRow class="align-items-center">
                                        <CCol sm="6">
                                            <CRow form class="form-group mb-0">
                                                <CCol sm="6">
                                                    <CInputCheckbox
                                                        type="checkbox"
                                                        label="Coach"
                                                        name="coach"
                                                        :checked.sync="coach"
                                                        custom
                                                    />
                                                </CCol>
                                                <CCol sm="6">
                                                    <CInputCheckbox
                                                        type="checkbox"
                                                        label="Rower"
                                                        name="rower"
                                                        :checked.sync="rower"
                                                        custom
                                                    />
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol sm="6" style="text-align:right">
                                            <CButton class="ml-auto px-5" color="info" type="submit" :disabled="this.graphqlLoadingFlag">NEXT</CButton>
                                        </CCol>
                                    </CRow>
                                    <FormErrors :errors="errors"/>
                                </CForm>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </div>
    </PortalAuth>
</template>

<script>
    import {
        getProcessedAuthResponseErrorsFlat,
        getSetInitialUserInfoMutation,
        doRedirectToNextParamOrDefaultPage, fetchMyUser
    } from '@/scripts/auth-utils'
    import {onSubmitHandler} from '@/scripts/forms-utils'
    import PortalAuth from '@/components/layouts/PortalAuth'
    import FormErrors from '@/components/FormErrors'

    export default {
        components: {PortalAuth, FormErrors},
        data() {
            return {
                rower: false,
                coach: false,
                errors: [],
                graphqlLoadingFlag: false
            }
        },
        methods: {
            async onSubmit() {
                let mutation = getSetInitialUserInfoMutation(this.rower, this.coach)
                await onSubmitHandler(this, mutation,
                    {
                        setErrorsF: (errors, scope) => scope.errors = getProcessedAuthResponseErrorsFlat(errors),
                        onSuccessF: async () => {
                            await fetchMyUser()
                            await doRedirectToNextParamOrDefaultPage('feed')
                        }
                    })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @media screen and (max-width: 576px) {
        .btn-info {
            margin-top: 20px;
        }
    }
</style>
